export default __webpack_public_path__ + "static/media/header-clouds.f658852a.svg";